import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["viewBox"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  fill: "transparent",
  cx: "50%",
  cy: "50%",
  r: "35%"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("line", {
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("line", {
  x1: "0%",
  x2: "100%",
  y1: "50%",
  y2: "50%",
  "stroke-dasharray": "5%,5%"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    role: "img",
    "aria-label": "Axial Rotation",
    class: "stroke-current overflow-visible origin-center",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    viewBox: '0 0 ' + _ctx.size + ' ' + _ctx.size,
    style: _normalizeStyle('transform: rotate(-' + _ctx.value + 'deg);' + 'width: ' + _ctx.size + 'px; height: ' + _ctx.size + 'px')
  }, [
    _hoisted_2,
    _createElementVNode("circle", {
      cx: "50%",
      cy: "50%",
      r: "15%",
      class: _normalizeClass([_ctx.circleColorClass, "fill-current"])
    }, null, 2),
    _hoisted_3,
    _hoisted_4
  ], 12, _hoisted_1))
}